import { c as _c } from "react/compiler-runtime";
import { useSyncGrowthbookUserAttributes } from 'growthbook/client';
import { HelpBots } from 'help-bots';
import Head from 'next/head';
import React from 'react';
import { Banner } from 'shared/components/banner';
import { Navbar } from 'shared/components/navbar';
import { useGuard } from 'shared/hooks/use-guard';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRedirectDisabledUser } from 'shared/hooks/use-redirect-disabled-user';
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names';
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification';
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification';
import { twMerge } from 'tailwind-merge';
import { Snow } from './snow';
import { useChristmas } from './snow/use-christmas';
interface DashboardLayoutProps extends React.PropsWithChildren {
  browserTabTitle: string;
}
function DashboardLayout(t0) {
  const $ = _c(17);
  const {
    children,
    browserTabTitle
  } = t0;
  useGuard();
  usePaymentNotification();
  useEmailStatusNotification();
  useRedirectDisabledUser();
  useSyncGrowthbookUserAttributes();
  const christmasFeatureIsOn = useChristmas();
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HelpBots />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== browserTabTitle || $[2] !== t) {
    t2 = t(browserTabTitle);
    $[1] = browserTabTitle;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Head><title>{t2}</title></Head>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Navbar />;
    t5 = <Banner />;
    t6 = twMerge(CONTENT_CLASSNAME, "py-5");
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== children) {
    t7 = <div>{t4}{t5}<main className={t6}>{children}</main></div>;
    $[9] = children;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== christmasFeatureIsOn) {
    t8 = christmasFeatureIsOn && <Snow />;
    $[11] = christmasFeatureIsOn;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t7 || $[15] !== t8) {
    t9 = <>{t1}{t3}{t7}{t8}</>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
export default DashboardLayout;